import { SavedFilters } from './types';
import * as React from 'react';

type SavedFiltersSetter = (newSavedFilters: SavedFilters) => void;
type SavedFiltersContextValues = [SavedFilters, SavedFiltersSetter];

const SelectedSavedFiltersContext =
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  React.createContext<SavedFiltersContextValues>(null);

/**
 * @description A hook for reading and setting the saved filters available
 * to the OE.
 */
function useSavedFilters() {
  const context = React.useContext(SelectedSavedFiltersContext);

  if (!context) {
    throw new Error(
      'useSavedFilters must be used within a SavedFiltersProvider',
    );
  }

  return context;
}

function SavedFiltersProvider(props: any) {
  const [selectedSavedFilters, setSelectedSavedFilters] =
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    React.useState<SavedFilters>(null);

  const value = React.useMemo(
    () => [selectedSavedFilters, setSelectedSavedFilters],
    [selectedSavedFilters],
  );

  return <SelectedSavedFiltersContext.Provider value={value} {...props} />;
}

export { SavedFiltersProvider, useSavedFilters };
